module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-left center"
  }, [_c('div', {
    staticClass: "rotate link--darkpink"
  }, [_c('router-link', {
    attrs: {
      "to": "/emoticons-text"
    }
  }, [_vm._v("▲"), _c('br'), _vm._v("Emoticons & Text")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-right center"
  }, [_c('div', {
    staticClass: "rotate link--darkpink"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About / Credits"), _c('br'), _vm._v("▼")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content--first lightpink text--darkgreen clear"
  }, [_c('expressive-type-animations'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium center link--end"
  }, [_c('router-link', {
    staticClass: "caps",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About / Credits")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap clear"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-section-title-conno caps rotate"
  }, [_vm._v("\n          Connotatives\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-section-number"
  }, [_vm._v("2–3")]), _vm._v(" "), _c('h1', [_vm._v("Expressive Type")]), _vm._v(" "), _c('p', {
    staticClass: "header-section-desc"
  }, [_vm._v("These typefaces are the divas of typography. Each one is connotative of mood, feeling, place, and/or time.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84b4800e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ExpressiveType.vue
// module id = 151
// module chunks = 0